/*eslint-disable*/
import { Flex, Link, Text, Box, Heading } from "@chakra-ui/react";
import React from "react";
import lineImage from "assets/img/line.png";
import facebookImage from "assets/img/facebook.png";

export default function Footer(props) {
  // const linkTeal = useColorModeValue("teal.400", "red.200");=
  return (
    <Box
      as="footer"
      bg="gray.300"
      borderTop="1px solid"
      borderColor="gray.300"
      py="2.5rem"
      fontSize="0.875rem"
    >
      <Box
        maxW="64rem"
        marginX="auto"
        pb="2rem"
        px={10}
        borderBottom="1px solid"
        borderColor="gray.300"
      >
        <Flex flexWrap="wrap" alignItems="start" justify="space-between">
          <Box w={{ base: '100%', sm: '50%', md: 'max-content' }} mb={{ base: '1.5rem', lg: '0' }}>
            <Heading as="h4" color="gray.600" mb="0.5rem" fontSize="0.875rem" fontWeight="600">
              โรงเรียนกวดวิชาคิดดี
            </Heading>
            <Text color={'gray.600'}>
              27/6 ถ.นครสวรรค์ อ.เมือง , Maha Sarakham, Thailand, 44000
            </Text>
            <Text color={'gray.600'}>
              +66 84 515 5165
            </Text>
          </Box>
          <Box w={{ base: '100%', sm: '50%', md: 'max-content' }} mb={{ base: '1.5rem', lg: '0' }}>
              <a href='https://line.me/R/ti/p/%40838jyolz' target="_blank">
                <Box p={2}>
                  <Box
                    bgImage={lineImage}
                    w='30px'
                    h='30px'
                    bgSize='cover'
                    bgPosition='50%'
                    position='absolute'
                    borderBottomLeftRadius='20px'>
                  </Box>
                  <Text color={'gray.600'} pl='10'>
                    @กวดวิชาคิดดี
                  </Text>
                </Box>
              </a>
              <a href='https://www.facebook.com/theKiddschool/' target="_blank">
                <Box p={2}>
                  <Box
                    bgImage={facebookImage}
                    w='30px'
                    h='30px'
                    bgSize='cover'
                    bgPosition='50%'
                    position='absolute'
                    borderBottomLeftRadius='20px'>
                  </Box>
                  <Text color={'gray.600'} pl='10'>
                    กวดวิชาคิดดี
                  </Text>
                </Box>
              </a>
          </Box>
        </Flex>
        <Flex
          flexDirection={{
            base: "column",
            xl: "row",
          }}
          alignItems={{
            base: "center",
            xl: "start",
          }}
          justifyContent="space-between"
        >
          
          <Text
            color="gray.400"
            textAlign={{
              base: "center",
              xl: "start",
            }}
            mb={{ base: "20px", xl: "0px" }}
          >
            &copy; {1900 + new Date().getYear()},{" "}
            <Text as="span">
              Made by  
            </Text>
            <Link
              // color={linkTeal}
              color="teal.400"
              href="https://www.facebook.com/theKiddschool/"
              target="_blank"
              ml='2px'
            >
              โรงเรียนกวดวิชาคิดดี
            </Link>
          </Text>
        </Flex>
      </Box>
    </Box>
  );
}
